export default {"src":"/_next/static/media/Ekata.ada69be5.svg","height":60,"width":60};